import { render, staticRenderFns } from "./PhotoSuggestionsSidebarTab.vue?vue&type=template&id=e64afd68&scoped=true"
import script from "./PhotoSuggestionsSidebarTab.vue?vue&type=script&lang=js"
export * from "./PhotoSuggestionsSidebarTab.vue?vue&type=script&lang=js"
import style0 from "./PhotoSuggestionsSidebarTab.vue?vue&type=style&index=0&id=e64afd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64afd68",
  null
  
)

export default component.exports